// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, HasPagingParameters, ServiceResult } from "@insite/client-framework/Services/ApiService";

const productsUrl = "/api/custom/products";

export interface GetProductVariantsApiParameter extends ApiParameter, HasPagingParameters {
    productId: string;
}

export interface VariantLinkModel {
    id: string;
    name: string;
    products: VariantLinkValueModel[] | null;
}

export interface ProductModelVariant {
    id: string;
    productUrl: string;
    productTitle: string;
}

export interface VariantLinkValueModel {
    id: string;
    selected: boolean;
    value: string;
    isDisabled?: boolean;
    product: ProductModelVariant;
}

export type VariantsResult = {
    variantTraits: VariantLinkModel[];
};

export async function getVariants(
    variantsApiParameter: GetProductVariantsApiParameter,
): Promise<ServiceResult<VariantsResult>> {
    const { productId, ...newParameter } = variantsApiParameter;

    try {
        const variants = await get<VariantsResult>(`${productsUrl}/${productId}/variants`, newParameter);
        return {
            successful: true,
            result: variants,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        // throw error; // Not critical enough to show an error to the user
        return {
            successful: false,
            errorMessage: "error",
        };
    }
}
